import { Module, Semester } from '@thro-types/modules-selections';

import { Lottery } from '../StudentView/models';

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Name: any;
  DateTime: any;
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID'];
  name: Scalars['String'];
  originalname: Scalars['String'];
};

export type Lecturer = {
  __typename?: 'Lecturer';
  id: Scalars['ID'];
  salutation: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  title: Scalars['String'];
  modules: Array<Module>;
};

export type Grouping = {
  id: number;
  description: string;
  name: string;
};

export type ParticipantsConfigurations = {
  __typename?: 'ParticipantsConfigurations';
  id: Scalars['ID'];
  courseOfStudyIds: Array<Scalars['Int']>;
  seats?: Maybe<Scalars['Int']>;
  admissionCriteria: Array<Semester>;
  prioritization: Array<Priority>;
  isGlobal: Scalars['Boolean'];
};

export type Prioritization = {
  __typename?: 'Prioritization';
  id: Scalars['ID'];
  prioritization: Array<Priority>;
};

export type Priority = {
  __typename?: 'Priority';
  priority: Scalars['Float'];
  semester: Scalars['String'];
};

export type CreateAttachmentInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type CreateDefaultModuleInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  info: Scalars['String'];
  grouping: Scalars['String'];
  sorting: Scalars['String'];
  attachment: Array<CreateAttachmentInput>;
  subjectType: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  timeframe: Scalars['String'];
  minParticipants: Scalars['Float'];
  maxParticipants: Scalars['Float'];
  isTakingPlace: Scalars['Boolean'];
  isMoveUpActive: Scalars['Boolean'];
  participantsConfigurations: Array<CreateParticipantsConfigurationInput>;
  lecturerId: Scalars['Float'];
};

export type CreateLecturerInput = {
  firstName: Scalars['String'];
  salutation: Scalars['String'];
  lastName: Scalars['String'];
  title: Scalars['String'];
};

export type CreateParticipantsConfigurationInput = {
  courseOfStudyIds: Array<Scalars['Float']>;
  seats: Scalars['Float'];
  admissionCriteria: Array<Semester>;
  prioritization: Array<CreatePriorityInput>;
  isGlobal: Scalars['Boolean'];
};

export type CreatePriorityInput = {
  priority: Scalars['Float'];
  semester: Scalars['String'];
};

export type CreateSelectionModuleInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  info: Scalars['String'];
  grouping: Scalars['String'];
  sorting: Scalars['String'];
  attachment: Array<CreateAttachmentInput>;
  subjectType: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  timeframe: Scalars['String'];
  minParticipants: Scalars['Float'];
  maxParticipants: Scalars['Float'];
  isTakingPlace: Scalars['Boolean'];
  isMoveUpActive: Scalars['Boolean'];
  participantsConfigurations: Array<CreateParticipantsConfigurationInput>;
  lecturerId: Scalars['Float'];
  selectionId: Scalars['Float'];
};

export type UpdateAttachmentInput = {
  name: Scalars['String'];
  url: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  moduleId?: Maybe<Scalars['Float']>;
};

export type UpdateModuleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  groupingId?: Maybe<Scalars['Int']>;
  sorting?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<UpdateAttachmentInput>>;
  subjectType?: Maybe<Scalars['String']>;
  timeframe?: Maybe<Scalars['String']>;
  minParticipants?: Maybe<Scalars['Float']>;
  maxParticipants?: Maybe<Scalars['Float']>;
  isTakingPlace?: Maybe<Scalars['Boolean']>;
  isMoveUpActive?: Maybe<Scalars['Boolean']>;
  participantsConfigurations?: Maybe<Array<UpdateParticipantsConfigurationInput>>;
  lecturerId?: Maybe<Scalars['Float']>;
};

export type UpdateLecturerInput = {
  firstName?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateParticipantsConfigurationInput = {
  courseOfStudyIds: Array<Scalars['Float']>;
  seats?: Maybe<Scalars['Float']>;
  admissionCriteria?: Maybe<Array<Semester>>;
  prioritization?: Maybe<Array<CreatePriorityInput>>;
  id?: Maybe<Scalars['ID']>;
  moduleId?: Maybe<Scalars['Float']>;
};

export type ModuleSelection = {
  __typename?: 'ModuleSelection';
  id: Scalars['ID'];
  subjectType: SubjectType;
  title: Scalars['String'];
  createdByCourseId?: Scalars['Float'];
  participatingCourseIds?: Maybe<Array<Scalars['Float']>>;
  generalNotes?: Scalars['String'];
  electionTip?: Scalars['String'];
  attachments?: Maybe<Array<Attachment>>;
  startDate?: Scalars['DateTime'];
  endDate?: Scalars['DateTime'];
  contentVisibleFrom?: Scalars['DateTime'];
  dischargeByStudentsUntil?: Scalars['DateTime'];
  lengthOfTheWishlist?: Scalars['Float'];
  maxSelectedModules?: Scalars['Float'];
  activeInAllCommunities?: Scalars['Boolean'];
  courseId?: Scalars['Float'];
  state: State;
  studentsAlreadyNotified?: Scalars['Boolean'];
  publishedAt?: Date;
  observers: Observer[];
};

export enum ObserverType {
  ROLE = 'ROLE',
  USER = 'USER'
}
export type Observer = {
  id: number;
  observerType: keyof typeof ObserverType;
  createdAt: Date;
  updatedAt: Date;
  refId: number;
  moduleSelection?: ModuleSelection;
  selectionId: number;
};

export type ModuleStudentSelection = {
  __typename?: 'ModuleSelection';
  id: Scalars['ID'] | number;
  subjectType: SubjectType;
  title: Scalars['String'];
  createdByCourseId?: Scalars['Float'];
  participatingCourseIds?: Maybe<Array<Scalars['Float']>>;
  generalNotes?: Scalars['String'];
  electionTip?: Scalars['String'];
  attachments?: Maybe<Array<Attachment>>;
  startDate?: Scalars['DateTime'];
  endDate?: Scalars['DateTime'];
  contentVisibleFrom?: Scalars['DateTime'];
  dischargeByStudentsUntil?: Scalars['DateTime'];
  lengthOfTheWishlist?: Scalars['Float'];
  maxSelectedModules?: Scalars['Float'];
  activeInAllCommunities?: Scalars['Boolean'];
  lottery?: Lottery;
  state: State;
};

export enum Ordered {
  Ascending = 'asc',
  Descending = 'desc'
}

export type CourseInput = {
  id: Scalars['ID'];
};

export type CreateModuleSelectionInput = {
  subjectType: SubjectType;
  title: Scalars['String'];
  generalNotes: Scalars['String'];
  participants?: Maybe<Array<CourseInput>>;
  electionTip: Scalars['String'];
  attachments: Array<CreateAttachmentInput>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  contentVisibleFrom: Scalars['DateTime'];
  dischargeByStudentsUntil: Scalars['DateTime'];
  lengthOfTheWishlist: Scalars['Float'];
  maxSelectedModules: Scalars['Float'];
  activeInAllCommunities: Scalars['Boolean'];
  state?: Maybe<State>;
};

export type UpdateModuleSelectionInput = {
  subjectType?: Maybe<SubjectType>;
  title?: Maybe<Scalars['String']>;
  generalNotes?: Maybe<Scalars['String']>;
  electionTip?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<UpdateAttachmentInput>>;
  participants?: Maybe<Array<CourseInput>>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  contentVisibleFrom?: Maybe<Scalars['DateTime']>;
  dischargeByStudentsUntil?: Maybe<Scalars['DateTime']>;
  maxSelectedModule?: Maybe<Scalars['Float']>;
  activeInAllCommunities?: Maybe<Scalars['Boolean']>;
};

export enum State {
  Started = 'STARTED',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Draft = 'DRAFT',
  Completed = 'COMPLETED',
  Dischargable = 'DISCHARGABLE',
  Archived = 'ARCHIVED'
}

export enum SelectionState {
  NotVisible = 'NotVisible',
  Visible = 'Visible',
  Active = 'Active',
  SignOutPossible = 'SignOutPossible',
  ReadOnly = 'ReadOnly'
}

export enum SubjectType {
  Awpm = 'AWPM',
  Fwpm = 'FWPM'
}
export interface UsersQueryArgs {
  type?: string;
  application?: string;
  offset?: number;
  entitlements?: string[];
  limit?: number;
  ids?: number[];
  filter?: string;
}

export type AddModuleSelectionMutationVariables = Exact<{
  data: CreateModuleSelectionInput;
}>;

export type AddModuleSelectionMutation = { __typename?: 'Mutation' } & {
  addModuleSelection: { __typename?: 'ModuleSelection' } & Pick<ModuleSelection, 'id'>;
};
